module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "device-list"
    }
  }, [_c('loading', {
    attrs: {
      "show": _vm.isLoading,
      "text": "加载中"
    }
  }), _vm._v(" "), (_vm.isNoDevice == true) ? _c('div', {
    staticClass: "no-device"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/home/bg_noDevice.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-size-m text-align-center"
  }, [_vm._v("当前还没有设备，")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-m text-align-center"
  }, [_vm._v("请点击“添加设备”按钮进行设置")])]) : _vm._e(), _vm._v(" "), (_vm.isNoDevice == false) ? _c('device-panel', {
    attrs: {
      "deviceList": _vm.deviceList
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49d6b04e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home/deviceLIst/Index.vue
// module id = 890
// module chunks = 1